import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["loading", "loadingAriaLabel"];
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useRef, useCallback, useMemo } from 'react';
import clsx from 'clsx';
import { LoadingIndicator } from '../loading-indicator/loading-indicator.js';
import styles from './text-input.module.js';
import { BaseTextInput } from '../primitives/base-text-input/base-text-input.js';
import { useForkRef } from '../utils/useForkRef.js';
var TextInput = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      loadingAriaLabel = props.loadingAriaLabel,
      rest = _objectWithoutProperties(props, _excluded);

  var inputRef = useRef(null);
  var focusInput = useCallback(function () {
    var _inputRef$current;

    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  }, []);
  var isLoading = !props.disabled && loading && loadingAriaLabel;
  var icon = useMemo(function () {
    return isLoading && jsx(LoadingIndicator, {
      "aria-label": loadingAriaLabel,
      className: styles.iconLoading,
      onClick: focusInput
    });
  }, [isLoading, loadingAriaLabel, focusInput]);
  return jsx(BaseTextInput, _objectSpread(_objectSpread({}, rest), {}, {
    ref: useForkRef(inputRef, forwardedRef),
    className: clsx(styles.textInput, props.className)
  }, icon ? {
    icon: icon
  } : {}));
});
TextInput.displayName = 'TextInput';
export { TextInput };